import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import { useDispatch } from "react-redux"
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { useLocation } from "react-router-dom";
import {sidebarItems} from '../../helpers/sidebarItems'
import { Link } from "react-router-dom";


export default function DrawerComponent({drawerOpen, toggleDrawer}) {
  const location = useLocation()


  const list = (anchor) => (
    <div
     
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        {sidebarItems.map((item, index) => (
           <Link key={item.id} to ={`${item.to}`} >

          <ListItem button key={item.name} id= {location.pathname === item.to && 'nav-active'} >
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText primary={item.name} />
          </ListItem>
        </Link>

        ))}
      </List>
     
    </div>
  );

  return (
    <div>
        <React.Fragment key={'left'}>
          <Drawer transitionDuration={2000} id= "custom-drawer" anchor={'left'} open={drawerOpen} onClose={toggleDrawer(false)} style= {{top: '55px'}}>
            {list('left')}
          </Drawer>
        </React.Fragment>
    </div>
  );
}
